import styled from '@emotion/styled'
import { Card, Container } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const Header = styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getPxAsRem(16)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    padding: ${getPxAsRem(16)};
    height: auto;
    min-height: ${getPxAsRem(500)};
    overflow: auto;
    border-radius: ${getPxAsRem(8)};
`
